import React, { useState, useEffect } from 'react';

const AITooltip = () => {
  const [isVisible, setIsVisible] = useState(false);
  const TOOLTIP_SESSION_KEY = 'aiTooltipShown';

  useEffect(() => {
    const hasBeenShown = sessionStorage.getItem(TOOLTIP_SESSION_KEY);
    let timer;
    if (!hasBeenShown) {
      setIsVisible(true);
      sessionStorage.setItem(TOOLTIP_SESSION_KEY, 'true');
      timer = setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Auto-dismiss after 5 seconds
    }

    return () => {
      clearTimeout(timer); // Clean up the timer
    };
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 bg-blue-600 text-white p-3 rounded-lg shadow-lg flex items-center justify-between z-50 max-w-xs">
      <p className="text-sm font-medium mr-2">Highlight text to use AI editing features!</p>
      <button
        onClick={handleDismiss}
        className="text-white hover:text-gray-200 focus:outline-none"
        aria-label="Dismiss tooltip"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>
  );
};

export default AITooltip;